import React from "react";
import cx from "classnames";
import {add3Dots} from "../common/function";
import {LENGTH} from "../common/constant";

function hexToRGB(hexCode, alpha) {
    const hex = hexCode.replace("#", "");
    let r, g, b;

    if (hex.length === 3) {
        r = parseInt(hex.substring(0, 1), 16);
        g = parseInt(hex.substring(1, 2), 16);
        b = parseInt(hex.substring(2, 3), 16);
    } else {
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
    }

    if (alpha) {
        return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
        return "rgb(" + r + ", " + g + ", " + b + ")";
    }
}

function UTags(props) {
    return (
        <React.Fragment>
            {props.type === "linear" ? (
                <div
                    className={`u_tag u_tag-linear ${props.className}`}
                    style={{...props.style, borderColor: props.color}}
                    onClick={props.onClick}
                >
                    <p style={{color: props.color}}>{add3Dots(props.title, props.length || LENGTH.TAGS, props.showFullTitle)}</p>
                    {props?.icon && <span className="u_ml-10 u_lh-0">{props?.icon}</span>}
                </div>
            ) : (
                <div
                    className={cx("u_tag", props.className)}
                    style={{...props.style, backgroundColor: hexToRGB(props.color, 0.10)}}
                    onClick={props.onClick}
                >
                    {props.type === "dot" && <span style={{backgroundColor: props.color}} className="u_tag-dot"/>}
                    {props?.iconBefore && props?.iconBefore}
                    <p style={{color: props.color}} className={props.type === "dot" ? 'u_pl-10' : ''}>{add3Dots(props.title, props.length || LENGTH.TAGS, props.showFullTitle)}</p>
                    {props?.icon && <span className="u_ml-10 u_lh-0">{props?.icon}</span>}
                </div>
            )}
        </React.Fragment>
    );
}

UTags.propTypes = {};
UTags.defaultProps = {};

export default UTags;
